import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedActresses from './components/FeaturedActresses';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import SearchBar from '@/components/base/SearchBar';
import { getAllActresses } from '@/mocks/actresses';
import ActressCard from '@/components/base/ActressCard';

export default function Home() {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  const allActresses = getAllActresses();
  const filteredActresses = searchQuery
    ? allActresses.filter(
        (a) =>
          a.name.includes(searchQuery) ||
          a.nameJp.includes(searchQuery) ||
          a.tags.some((t) => t.includes(searchQuery))
      )
    : [];

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '日本女优大全 - 首页',
    description: '日本女优大全是您查找日本演艺女优最全面的参考资源，收录数千位女优的详细资料、出道背景、代表作品与最新动态。',
    url: 'https://www.ribennvyou.com/',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '日本女优大全',
      url: 'https://www.ribennvyou.com/',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="日本女优大全 - 完整收录与详细介绍 | 日本演艺女优资料库"
        description="日本女优大全是您查找日本演艺女优最全面的参考资源，收录数千位女优的详细资料、出道背景、代表作品与最新动态，帮助影迷快速找到心仪的女优信息。"
        keywords="日本女优大全,日本女优名单,日本女优资料库,日本女优出道信息,日本女优代表作,日本演艺女优介绍"
        canonicalUrl="https://www.ribennvyou.com/"
        schema={webPageSchema}
      />
      <Navbar />
      <main>
        <HeroSection />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-4">
                搜索女优
              </h2>
              <p className="text-sm text-foreground-600">
                输入女优姓名，快速查找详细资料
              </p>
            </div>
            <SearchBar large />
          </div>
        </section>

        {searchQuery && (
          <section className="py-10 md:py-14 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-2">
                搜索结果：<span className="text-primary-600">"{searchQuery}"</span>
              </h2>
              <p className="text-sm text-foreground-500 mb-6">
                找到 {filteredActresses.length} 位相关女优
              </p>
              {filteredActresses.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                  {filteredActresses.map((actress) => (
                    <ActressCard key={actress.id} actress={actress} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                    <i className="ri-search-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-600">未找到相关女优，请尝试其他关键词</p>
                </div>
              )}
            </div>
          </section>
        )}

        <FeaturedActresses />
        <CategoryNav />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}